import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Upload } from "lucide-react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVehicle } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function createData(
  attachments,
  batteryid,
  manufacturerName,
  purchaseDate,
  isActive,
  warrantyPeriod,
  costToCompany,
  totalCost,
  warrantyStartDate,
  warrantyEndDate,
  isInstalled,
  dateOfInstallation,
  isSwapped,
  swappedFromVehicleId,
  vendorName,
  vendorContact,
  vendorAddress,
  isPaymentPending,
  createdAt,
  rawData,
) {
  return {
    attachments,
    batteryid,
    manufacturerName,
    purchaseDate,
    isActive,
    warrantyPeriod,
    costToCompany,
    totalCost,
    warrantyStartDate,
    warrantyEndDate,
    isInstalled,
    dateOfInstallation,
    isSwapped,
    swappedFromVehicleId,
    vendorName,
    vendorContact,
    vendorAddress,
    isPaymentPending,
    createdAt,
    rawData,
  };
}

const Batteries = ({ selectedRow }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issuePriority;
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [errors, setErrors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [myBatteries, setMyBatteries] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editBatteryId, setEditBatteryId] = useState(null);
  const [open, setOpen] = useState(false);

  const handleImageOpen = (img) => {
    setPreviewImage(img);
    setPreviewOpen(true);
  };

  const generalInformationofBatteries = [
    {
      label: "Battery Id",
      value: "batteryId",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Date of Manufacturing",
      value: "dateOfManufacturing",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Manufactured By",
      value: "manufacuturedBy",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty Period",
      value: "warrantyPeriod",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Purchase Date",
      value: "purchaseDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty Start Date",
      value: "startDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty End Date",
      value: "endDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Installed Date",
      value: "installedDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Is Installed",
      value: "isInstalled",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Is Swapped",
      value: "isSwapped",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Swapped Old Vehicle no",
      value: "vehicleNo",
      type: "dropdown",
      disabled: false,
      subCategory:
        vehicles &&
        Object.entries(vehicles).map(([key, item]) => ({
          value: item?.licensePlate + "__" + item?.name, // or whatever property you want
          label: item?.id,
        })),
    },
    {
      label: "Issue Id",
      value: "issueId",
      type: "dropdown",
      disabled: false,
      subCategory:
        myIssues &&
        Object.entries(myIssues).map(([key, item]) => ({
          value: item?.code, // or whatever property you want
          label: item?.id,
        })),
    },
    {
      label: "Vendor Name",
      value: "vendorName",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vendor Contact",
      value: "vendorContact",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vendor Address",
      value: "vendorAddress",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Is Payment Pending",
      value: "isPaymentPending",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Cost to Company",
      value: "costToCompany",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Cost",
      value: "totalCost",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Attachments",
      value: "attachments",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  // const columns = [
  //   {
  //     field: "id",
  //     headerName: "Id",
  //     minWidth: 100,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "batteryid",
  //     headerName: "Battery ID",
  //     minWidth: 250,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "manufacturerName",
  //     headerName: "Manufacturer Name",
  //     minWidth: 200,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "purchaseDate",
  //     headerName: "Purchase Date",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "isActive",
  //     headerName: "Is Active",
  //     minWidth: 190,
  //     align: "start",
  //   },
  //   {
  //     field: "warrantyPeriod",
  //     headerName: "Warranty Period",
  //     minWidth: 150,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "warrantyStartDate",
  //     headerName: "Warranty Start Date",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "warrantyEndDate",
  //     headerName: "Warranty End Date",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "isInstalled",
  //     headerName: "is Insalled",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "dateOfInstallation",
  //     headerName: "Date of Installation",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "isSwapped",
  //     headerName: "Is Swapped",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "swappedFromVehicleId",
  //     headerName: "Swapped From Vehicle ID",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "vendorName",
  //     headerName: "Vendor Name",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "vendorContact",
  //     headerName: "Vendor Contact",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "vendorAddress",
  //     headerName: "Vendor Address",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "edit",
  //     headerName: "Edit",
  //     minWidth: 150,
  //     align: "start",
  //     renderCell: (params) => (
  //       <Button
  //         sx={{ color: "white", bgcolor: "#1227e6", fontWeight: 700 }}
  //         onClick={() => handleEdit(params.row)}
  //       >
  //         Edit
  //       </Button>
  //     ),
  //   },
  // ];

  // Helper function to convert formatted date (e.g., "20-Jan-2026 12:00 AM") to YYYY-MM-DD
  const formatDateToInput = (dateString) => {
    if (!dateString) return "";

    // Handle ISO format (2026-01-20T00:00:00)
    if (dateString.includes("T")) {
      return dateString.split("T")[0];
    }

    // Handle formatted date (20-Jan-2026 12:00 AM)
    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };

    const parts = dateString.split(" ");
    const dateParts = parts[0].split("-");

    if (dateParts.length === 3) {
      const day = dateParts[0].padStart(2, "0");
      const month = months[dateParts[1].toLowerCase()] || dateParts[1];
      const year = dateParts[2];
      return `${year}-${month}-${day}`;
    }

    return dateString;
  };

  const handleEdit = (row) => {
    setHideTestFields(true);
    setIsEdit(true);
    setEditBatteryId(row.id);

    const rawBattery = myBatteries.find((b) => b.id === row.id);

    // Parse attachments if it's a JSON string
    let parsedAttachments = [];
    try {
      const attachmentsData = row?.attachments || rawBattery?.attachments;
      if (typeof attachmentsData === "string") {
        parsedAttachments = JSON.parse(attachmentsData);
      } else if (Array.isArray(attachmentsData)) {
        parsedAttachments = attachmentsData;
      }
    } catch (e) {
      parsedAttachments = [];
    }

    setForm({
      batteryId: row?.batteryid || rawBattery?.batteryId || "",
      dateOfManufacturing: formatDateToInput(
        rawBattery?.dateOfInstallation || row?.dateOfInstallation || "",
      ),
      manufacuturedBy:
        row?.manufacturerName || rawBattery?.manufacturerName || "",
      warrantyPeriod: row?.warrantyPeriod || rawBattery?.warrantyPeriod || "",
      purchaseDate: formatDateToInput(
        rawBattery?.purchaseDate || row?.purchaseDate || "",
      ),
      startDate: formatDateToInput(
        rawBattery?.warrantyStartDate || row?.warrantyStartDate || "",
      ),
      endDate: formatDateToInput(
        rawBattery?.warrantyEndDate || row?.warrantyEndDate || "",
      ),
      installedDate: formatDateToInput(
        rawBattery?.dateOfInstallation || row?.dateOfInstallation || "",
      ),
      isInstalled: row?.isInstalled ? "true" : "false",
      isSwapped: row?.isSwapped ? "true" : "false",
      vehicleNo:
        row?.swappedFromVehicleId || rawBattery?.swappedFromVehicleId || null,
      issueId: row?.issueId || null,
      vendorName: row?.vendorName || rawBattery?.vendorName || null,
      vendorContact: row?.vendorContact || rawBattery?.vendorContact || null,
      vendorAddress: row?.vendorAddress || rawBattery?.vendorAddress || null,
      attachments: parsedAttachments,
      isPaymentPending: row?.isPaymentPending ? "true" : "false",
      costToCompany: row?.costToCompany || rawBattery?.costToCompany || null,
      totalCost: row?.totalCost || rawBattery?.totalCost || null,
    });

    // Set uploaded images for preview
    if (row?.attachments) {
      try {
        const attachments =
          typeof row.attachments === "string"
            ? JSON.parse(row.attachments)
            : row.attachments;
        setUploadedImages(attachments);
      } catch (e) {
        setUploadedImages(row?.attachments || null);
      }
    }

    // Scroll to the form section
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const rows =
    (myBatteries &&
      myBatteries?.map((item) =>
        createData(
          item?.attachments,
          item?.batteryId,
          item?.manufacturerName,
          formatDateAndTime(item?.purchaseDate) || "-",
          item?.isActive,
          item?.warrantyPeriod,
          item?.costToCompany,
          item?.totalCost,
          formatDateAndTime(item?.warrantyStartDate),
          formatDateAndTime(item?.warrantyEndDate),
          item?.isInstalled,
          formatDateAndTime(item?.dateOfInstallation),
          item?.isSwapped,
          item?.swappedFromVehicleId,
          item?.vendorName,
          item?.vendorContact,
          item?.vendorAddress,
          item?.isPaymentPending,
          formatDateAndTime(item?.createdAt),
          item,
        ),
      )) ||
    [];

  const getVehicleBatteries = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/batterydetails?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyBatteries(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleIssues = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleAPI = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=${1000}&offset=${0}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setVehicles(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    }
  };

  useEffect(() => {
    if (selectedRow) {
      getVehicleBatteries(
        selectedRow.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
      getVehicleIssues(
        selectedRow.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
      getVehicleAPI();
    }
  }, [selectedRow, paginationModel]);

  const handleChange = async (field, value) => {
    if (field === "attachments") {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({
          ...prev,
          [field]: res?.uploaded || "",
        }));
      });
    } else {
      setForm((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    // Battery ID
    if (!form.batteryId?.trim()) {
      newErrors.batteryId = "Battery ID is required";
    }

    // Date of Manufacturing
    if (!form.dateOfManufacturing) {
      newErrors.dateOfManufacturing = "Manufacturing date is required";
    } else if (new Date(form.dateOfManufacturing) > new Date()) {
      newErrors.dateOfManufacturing = "Manufacturing date cannot be future";
    }

    // Manufactured By
    if (!form.manufacuturedBy?.trim()) {
      newErrors.manufacuturedBy = "Manufacturer name is required";
    }

    // Warranty
    if (!form.warrantyPeriod) {
      newErrors.warrantyPeriod = "Warranty period is required";
    } else if (Number(form.warrantyPeriod) <= 0) {
      newErrors.warrantyPeriod = "Warranty must be greater than 0";
    }

    // Start Date
    if (!form.startDate) {
      newErrors.startDate = "Start date is required";
    } else if (
      form.dateOfManufacturing &&
      new Date(form.startDate) < new Date(form.dateOfManufacturing)
    ) {
      newErrors.startDate = "Start date must be after manufacturing date";
    }

    // End Date
    if (!form.endDate) {
      newErrors.endDate = "End date is required";
    } else if (
      form.startDate &&
      new Date(form.endDate) < new Date(form.startDate)
    ) {
      newErrors.endDate = "End date must be after start date";
    }

    // Is Installed
    if (form.isInstalled === undefined) {
      newErrors.isInstalled = "Please select installation status";
    }

    // Installed Date (only if installed)
    if (form.isInstalled === "true" && !form.installedDate) {
      newErrors.installedDate = "Installed date is required";
    }

    // Is Swapped
    if (form.isSwapped === undefined) {
      newErrors.isSwapped = "Please select swap status";
    }

    if (!form.vendorAddress) {
      newErrors.vendorAddress = "Please add Vendor Address";
    }

    if (!form.vendorContact) {
      newErrors.vendorContact = "Please add Vendor Contact";
    }

    if (!form.vendorName) {
      newErrors.vendorName = "Please add Vendor Name";
    }

    // Attachments
    if (!form.attachments || form.attachments.length === 0) {
      newErrors.attachments = "At least one attachment is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddNewBattery = async () => {
    let payload = {};
    if (editBatteryId) {
      payload = {
        id: editBatteryId?.id,
        batteryId: form?.batteryId,
        manufacturerName: form?.manufacuturedBy,
        purchaseDate: form?.purchaseDate,
        vehicleId: selectedRow?.id,
        isActive: "true",
        warrantyPeriod: form?.warrantyPeriod,
        warrantyStartDate: form?.startDate,
        warrantyEndDate: form?.endDate,
        isInstalled: form?.isInstalled === "true" ? 1 : 0,
        dateOfInstallation: form?.installedDate,
        isSwapped: form?.isSwapped,
        swappedFromVehicleId: form?.vehicleNo,
        issueId: form?.issueId,
        attachments: JSON.stringify(form?.attachments),
        vendorName: form?.vendorName,
        vendorContact: form?.vendorContact,
        vendorAddress: form?.vendorAddress,
        isPaymentPending: form?.isPaymentPending === "true" ? 1 : 0,
        costToCompany: Number(form?.costToCompany),
        totalCost: Number(form?.totalCost),
      };
    } else {
      payload = {
        // id: selectedRow?.id,
        batteryId: form?.batteryId,
        manufacturerName: form?.manufacuturedBy,
        purchaseDate: form?.purchaseDate,
        vehicleId: selectedRow?.id,
        isActive: "true",
        warrantyPeriod: form?.warrantyPeriod,
        warrantyStartDate: form?.startDate,
        warrantyEndDate: form?.endDate,
        isInstalled: form?.isInstalled === "true" ? 1 : 0,
        dateOfInstallation: form?.installedDate,
        isSwapped: form?.isSwapped,
        swappedFromVehicleId: form?.vehicleNo,
        issueId: form?.issueId,
        attachments: JSON.stringify(form?.attachments),
        vendorName: form?.vendorName,
        vendorContact: form?.vendorContact,
        vendorAddress: form?.vendorAddress,
        isPaymentPending: form?.isPaymentPending === "true" ? 1 : 0,
        costToCompany: Number(form?.costToCompany),
        totalCost: Number(form?.totalCost),
      };
    }
    try {
      const response = await fetch(`${apiUrl}/api/batterydetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({});
        setUploadedImages(null);
        toast.success("New Battery Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setErrors({});
        setEditBatteryId(null);
        setIsEdit(false);
        getVehicleBatteries(
          selectedRow.id,
          paginationModel.page,
          paginationModel.pageSize,
        );
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Battery Details</h1>{" "}
        {hideTextfields ? (
          <CloseIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(false);
            }}
          />
        ) : (
          <AddCircleOutlineIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(true);
            }}
          />
        )}
      </div>
      {hideTextfields && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 p-6 rounded-lg">
            {generalInformationofBatteries.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {/* DROPDOWN */}
                {field.type === "dropdown" && (
                  <FormControl fullWidth size="small">
                    <InputLabel id={`select-label-${index}`}>
                      {field.label}
                    </InputLabel>

                    <Select
                      labelId={`select-label-${index}`}
                      value={form[field.value] || ""}
                      label={field.label}
                      disabled={field.disabled}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4f46e5",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted")
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {/* FILE UPLOAD */}
                {field.type === "file" && (
                  <div className="space-y-2">
                    <Button
                      component="label"
                      variant="outlined"
                      fullWidth
                      disabled={field.disabled}
                      startIcon={<Upload size={18} />}
                      sx={{
                        borderStyle: "dashed",
                        borderRadius: "8px",
                        padding: "12px",
                        color: "#4f46e5",
                        borderColor: "#a5b4fc",
                        "&:hover": {
                          borderColor: "#6366f1",
                          backgroundColor: "#eef2ff",
                        },
                      }}
                    >
                      {form[field.value]?.length
                        ? "Change Files"
                        : "Upload Files"}
                      <input
                        hidden
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                      />
                    </Button>
                  </div>
                )}

                {/* TEXT / NUMBER / DATE */}
                {field.type !== "dropdown" && field.type !== "file" && (
                  <TextField
                    fullWidth
                    size="small"
                    type={field.type}
                    value={form[field.value] || ""}
                    disabled={field.disabled}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                      },
                    }}
                  />
                )}
              </div>
            ))}
          </div>
          {uploadedImages && (
            <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
              {uploadedImages?.length > 0 ? (
                <div className="mt-6 flex gap-4 flex-wrap">
                  {uploadedImages.map((image, index) => (
                    <img
                      key={index}
                      src={
                        image?.url || image?.Location || image?.path || image
                      }
                      alt="Image Preview"
                      className="w-28 h-28 rounded-lg object-cover border shadow"
                    />
                  ))}
                </div>
              ) : (
                <div className="mt-6 flex gap-4 flex-wrap">
                  <img
                    src={uploadedImages}
                    alt="Image Preview"
                    className="w-44 h-44 rounded-lg object-cover border shadow"
                  />
                </div>
              )}
            </div>
          )}
          <div className="flex justify-end p-6">
            {Object.keys(errors).length > 0 && (
              <div className="text-red-600 text-sm mb-4">
                <ul className="list-disc pl-5">
                  {Object.values(errors).map((err, index) => (
                    <li key={index}>{err}</li>
                  ))}
                </ul>
              </div>
            )}

            <button
              onClick={() => {
                if (!validateForm()) return;
                handleAddNewBattery();
              }}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700
  text-white font-semibold px-5 py-2.5 rounded-lg shadow-md"
            >
              {isEdit ? "Update" : "+ Add"}
            </button>
          </div>{" "}
        </>
      )}

      <div className="p-4">
        <div className="p-4 overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Attachments</TableCell>
                <TableCell>Battery ID</TableCell>
                <TableCell>Manufacturer Name</TableCell>
                <TableCell>Purchase Date</TableCell>
                <TableCell>Is Active</TableCell>
                <TableCell>Warranty Period</TableCell>
                <TableCell>Is Installed</TableCell>
                <TableCell>Date of Installation</TableCell>
                <TableCell>Is Swapped</TableCell>

                {/* Main Grid Cost Columns */}
                <TableCell>Cost To Company</TableCell>
                <TableCell>Total Cost</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.length > 0 ? (
                rows.map((r, index) => (
                  <React.Fragment key={index}>
                    {/* MAIN ROW */}
                    <TableRow hover sx={{ cursor: "pointer" }}>
                      {/* Expand Attachments */}
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpen(open === index ? -1 : index);
                          }}
                        >
                          {open === index ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </IconButton>
                      </TableCell>

                      {/* Battery ID */}
                      <TableCell>{r?.batteryid || "-"}</TableCell>

                      {/* Manufacturer */}
                      <TableCell>{r?.manufacturerName || "-"}</TableCell>

                      {/* Purchase Date */}
                      <TableCell>{r?.purchaseDate || "-"}</TableCell>

                      {/* Is Active */}
                      <TableCell>
                        <span
                          style={{
                            color: r?.isActive ? "green" : "red",
                            fontWeight: "bold",
                          }}
                        >
                          {r?.isActive ? "Yes" : "No"}
                        </span>
                      </TableCell>

                      {/* Warranty Period */}
                      <TableCell>{r?.warrantyPeriod || "-"}</TableCell>

                      {/* Is Installed */}
                      <TableCell>
                        <span
                          style={{
                            color: r?.isInstalled ? "green" : "red",
                            fontWeight: "bold",
                          }}
                        >
                          {r?.isInstalled ? "Yes" : "No"}
                        </span>
                      </TableCell>

                      {/* Date of Installation */}
                      <TableCell>{r?.dateOfInstallation || "-"}</TableCell>

                      {/* Is Swapped */}
                      <TableCell>
                        <span
                          style={{
                            color: r?.isSwapped ? "green" : "red",
                            fontWeight: "bold",
                          }}
                        >
                          {r?.isSwapped ? "Yes" : "No"}
                        </span>
                      </TableCell>

                      {/* COST TO COMPANY - MAIN COLUMN */}
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {r?.costToCompany !== null &&
                        r?.costToCompany !== undefined &&
                        r?.costToCompany !== ""
                          ? `₹ ${Number(r.costToCompany).toLocaleString("en-IN")}`
                          : "-"}
                      </TableCell>

                      {/* TOTAL COST - MAIN COLUMN */}
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {r?.totalCost !== null &&
                        r?.totalCost !== undefined &&
                        r?.totalCost !== ""
                          ? `₹ ${Number(r.totalCost).toLocaleString("en-IN")}`
                          : "-"}
                      </TableCell>

                      {r?.rawData?.serviceLogId &&
                        r?.rawData?.serviceLogId !== 0 ? (
                          <TableCell>
                            <Button
                              onClick={() => {
                                const navigate = `/workorder?orderid=${r?.rawData?.serviceLogId}&display=true`;
                                window.open(navigate, "_blank");
                              }}
                            >
                              View
                            </Button>
                          </TableCell>
                        ) : null}
                    </TableRow>

                    {/* EXPANDED DETAILS ROW */}
                    <TableRow>
                      <TableCell
                        colSpan={11}
                        sx={{
                          p: 0,
                          borderBottom: 0,
                        }}
                      >
                        <Collapse
                          in={open === index}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ p: 3 }}>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                              <div>
                                <b>Vendor Name:</b> {r?.vendorName || "-"}
                              </div>

                              <div>
                                <b>Vendor Contact:</b> {r?.vendorContact || "-"}
                              </div>

                              <div>
                                <b>Vendor Address:</b> {r?.vendorAddress || "-"}
                              </div>

                              <div>
                                <b>Is Payment Pending:</b>{" "}
                                {r?.isPaymentPending ? "Yes" : "No"}
                              </div>

                              <div>
                                <b>Warranty Start:</b>{" "}
                                {r?.warrantyStartDate || "-"}
                              </div>

                              <div>
                                <b>Warranty End:</b> {r?.warrantyEndDate || "-"}
                              </div>
                            </div>

                            {/* ATTACHMENTS */}
                            <Box
                              sx={{
                                mt: 3,
                                display: "flex",
                                gap: 2,
                                flexWrap: "wrap",
                              }}
                            >
                              {r?.attachments ? (
                                (() => {
                                  let files = [];

                                  try {
                                    files =
                                      typeof r.attachments === "string"
                                        ? JSON.parse(r.attachments)
                                        : r.attachments;

                                    if (!Array.isArray(files)) {
                                      files = [];
                                    }
                                  } catch (error) {
                                    files = [];
                                  }

                                  return files.length > 0 ? (
                                    files.map((file, i) => {
                                      const imageUrl =
                                        file?.url ||
                                        file?.Location ||
                                        file?.image ||
                                        file?.path ||
                                        file;

                                      return (
                                        <div key={i}>
                                          <img
                                            src={imageUrl}
                                            alt={`Attachment ${i + 1}`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleImageOpen(imageUrl);
                                            }}
                                            className="w-32 h-32 object-cover cursor-pointer rounded-lg border hover:opacity-80"
                                          />
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <Typography
                                      sx={{ color: "red" }}
                                      variant="body2"
                                    >
                                      No Attachments
                                    </Typography>
                                  );
                                })()
                              ) : (
                                <Typography
                                  sx={{ color: "red" }}
                                  variant="body2"
                                >
                                  No Attachments
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      py: 3,
                    }}
                  >
                    No Battery Details Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
      {previewOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setPreviewOpen(false)}
        >
          <img
            src={previewImage}
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

export default Batteries;
